// src/components/dashboard/wallet-grid.tsx
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import { Tooltip } from 'react-tooltip';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAuth } from "../../context/AuthContext";
import { useWindow } from '../../context/WindowContext';

import { mainService } from "../../services/api/main.service";

// import { updateTicketStatus } from '../../store/authReducer'
import { createCryptoWallet, getCryptoWallets } from "../../store/assetsReducer"

import WalletCard from './wallet/walletCard';
import MainAccount from "./MainAccount";
// import { RailDataCompletionForm } from "./rail-usd-wallet/RailDataCompletionForm";
import { MastercardCardSection } from "./mastercard/MastercardCardSection";
import CryptoWalletsInfoModal from "./CryptoWalletsInfoModal";

import "../../assets/styles/wallet-card.css";

import type { AppDispatch, RootState } from '../../store';
import { RailUserInfoUpdateRequest, WalletType } from "../../types/rail.types";
import { FIAT_WALLETS, CUSTODIAN_WALLETS, CRYPTO_WALLETS } from "../../constants/wallets"
import {CryptoWalletType, MainAccountType} from '../../types/assets.types';
import { getCurrentApiUrl } from '../../config/server.config';

export function WalletGrid() {

  const { user, isFullOnboarding } = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const { windowWidth } = useWindow();
  const { t } = useTranslation();

  const { data: { mainWallets, cryptoWallets, masterCard } } = useSelector((state: RootState) => state.assets);
  const { data: { cryptoPrices, fiatPrices }, status: rateStatus } = useSelector((state: RootState) => state.setting);
  const { data: ticketStatus } = useSelector((state: RootState) => state.auth.ticketStatus); 
  const [showUsdForm, setShowUsdForm] = useState<boolean>(false);
  // const [usdFormData, setUsdFormData] = useState<any>(null);
  // const [usdFormMissingFields, setUsdFormMissingFields] = useState<string[]>([]);
  const [isCheckingMainData, setIsCheckingMainData] = useState<boolean>(false);
  const [isCreatingApplication, setIsCreatingApplication] = useState<boolean>(false);
  const [showCryptoInfoModal, setShowCryptoInfoModal] = useState<boolean>(false);

  // Rail v1 deprecated - no longer needed in v2
  const checkUserApplications = async (): Promise<number> => {
    // Rail operations deprecated - always return 0
    return 0;
  };

  const createApplicationFromCompletedTicket = async () => {
    try {
      setIsCreatingApplication(true);
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await fetch('${getCurrentApiUrl()}/rail/individual/create-from-ticket', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      if (response.ok) {
        toast.info('Creating application...');

        // Esperar 10 segundos antes de verificar
        await new Promise(resolve => setTimeout(resolve, 10000));

        // Intentar verificar hasta 3 veces
        let attempts = 0;
        while (attempts < 3) {
          const totalRecords = await checkUserApplications();
          if (totalRecords > 0) {
            toast.success('Application created successfully');
            // await refetchRailAccounts();
            return true;
          }

          attempts++;
          if (attempts < 3) {
            await new Promise(resolve => setTimeout(resolve, 10000));
          }
        }

        toast.error('The application is taking longer than expected. Please refresh the page in a few moments.');
        return false;
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || 'Error creating application');
        return false;
      }
    } catch (error) {
      toast.error('Error creating application');
      return false;
    } finally {
      setIsCreatingApplication(false);
    }
  };

  useEffect(() => {
    const checkAndCreateApplication = async () => {
      // if (ticketStatus?.hasTicket && ticketStatus.isCompleted && !isCreatingApplication) {
      //   const totalApplications = await checkUserApplications();
      //   if (totalApplications === 0) {
      //     await createApplicationFromCompletedTicket();
      //   }
      // }
    };
    checkAndCreateApplication();
  }, [ticketStatus, isCreatingApplication]);

  // const getUserClientType = async (): Promise<string> => {
  //   try {
  //     const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  //     const response = await fetch('${getCurrentApiUrl()}/onboarding/current-phase', {
  //       headers: {
  //         'Authorization': `Bearer ${token}`
  //       }
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       return data.type || 'INDIVIDUAL';
  //     }
  //   } catch (error) {
  //     console.error('Error obteniendo tipo de cliente:', error);
  //   }
  //   return 'INDIVIDUAL';
  // };

  // const checkRailCompleteness = async (currency: string) => {

  //   setIsCheckingMainData(true);
  //   try {
  //     const totalApplications = await checkUserApplications();
  //     if (totalApplications > 0) {
  //       toast.info("You already have a wallet application in process");
  //       return;
  //     }

  //     if (ticketStatus && ticketStatus.hasTicket) {
  //       if (ticketStatus.isCompleted) {
  //         toast.info("Your application is being processed. It will be available soon.");
  //       } else {
  //         toast.info("Your wallet request is pending review by our team.");
  //       }
  //       return;
  //     }
  //     // const clientType = await getUserClientType();
  //     // if (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE') {
  //     //   await createTicketForRailAccount(currency);
  //     //   return;
  //     // }
  //     // const completenessData = await mainService.checkDataCompleteness() as any;
  //     // if (completenessData.missingFields && completenessData.missingFields.length === 0) {
  //     //   await createTicketForRailAccount(currency);
  //     // } else {
  //     //   setUsdFormData(completenessData.data);
  //     //   setUsdFormMissingFields(completenessData.missingFields);
  //     //   setShowUsdForm(true);
  //     // }
  //   } catch (error) {
  //     console.error('Error checking Rail completeness:', error);
  //     toast.error('Could not verify required data. Please try again.');
  //   } finally {
  //     setIsCheckingMainData(false);
  //   }
  // };

  // const createTicketForRailAccount = async (currency: string) => {
  //   try {

  //     const data = await mainService.createRailTicket(currency);
  //     if (data.success && data.ticketNumber) {
  //       toast.success(`Wallet request submitted successfully! Ticket #${data.ticketNumber}`);
  //       toast.info('Our team will review your documentation and create your wallet soon.');
  //       dispatch(updateTicketStatus({ hasTicket: true, isCompleted: false, ticketStatus: 'OPEN' }))
  //     } else {
  //       toast.error(data.message || 'Error creating wallet request');
  //     }
  //   } catch (error) {
  //     console.error('Error creating ticket:', error);
  //     toast.error('Error submitting wallet request. Please try again.');
  //   }
  // };

  // const handleRailFormSubmit = async (data: RailUserInfoUpdateRequest) => {
  //   try {

  //     await mainService.updateUserInfo(data);
  //     const completenessCheck = await mainService.checkDataCompleteness() as any;
  //     if (completenessCheck.missingFields && completenessCheck.missingFields.length === 0) {
  //       setShowUsdForm(false);
  //       await createTicketForRailAccount('USD');
  //     } else {
  //       toast.warning('There are still missing fields. Please complete all required information.');
  //       setUsdFormMissingFields(completenessCheck.missingFields);
  //     }
  //   } catch (error) {
  //     console.error('Error submitting Rail data:', error);
  //     toast.error(error instanceof Error ? error.message : 'Failed to update information');
  //   }
  // };

  // Auto-refresh crypto wallets every 5 minutes
  useEffect(() => {
    // Only start auto-refresh if crypto prices are loaded
    if (rateStatus !== 'succeeded' || !cryptoPrices) {
      return;
    }

    console.log('[Wallet Grid] Setting up crypto wallet auto-refresh (every 5 minutes)');

    // Function to refresh crypto wallets
    const refreshCryptoWallets = () => {
      console.log('[Wallet Grid] Auto-refreshing crypto wallet balances...');
      dispatch(getCryptoWallets(cryptoPrices));
    };

    // Initial load on component mount
    refreshCryptoWallets();

    // Set up interval for 5 minutes (300,000 milliseconds)
    const intervalId = setInterval(refreshCryptoWallets, 300000);

    // Cleanup interval on component unmount
    return () => {
      console.log('[Wallet Grid] Cleaning up crypto wallet auto-refresh');
      clearInterval(intervalId);
    };
  }, [dispatch, cryptoPrices, rateStatus]);

  const createWallet = async (wallet:CryptoWalletType): Promise<boolean> => {
    // const token = wallet.token;
    // const isFiatWallet = FIAT_WALLETS.find(w => w.currency === currency) !== undefined;

    // if (mainWallets.fiatWallets.data.length === 0 && wallet.type !== "2" && wallet.currency !== "USD") {
    //   toast.info(`Please create a USD Fiat Wallet to make ${currency} Wallet`);
    //   return null;
    // }

    // if (currency === 'USD') {
    //   if (isFullOnboarding()) {
    //     // checkRailCompleteness(currency);
    //   } else {
    //     toast.info("You need to complete the full onboarding process to create FIAT wallets.");
    //   }
    //   return null;
    // }

    // if (isFiatWallet && (currency !== 'USD' && currency !== 'EUR' && currency !== 'GBP')) {
    //   toast.info("Other FIAT wallets are not available at the moment");
    //   return null;
    // }

    try {
      // if (wallet.type == "3") {
       const res = await dispatch(createCryptoWallet(wallet.token)).unwrap();
      //  console.log(res);
       if (!res.success) return;
        await dispatch(getCryptoWallets(cryptoPrices))
        let token = "";
        let clonetoken = "";
        let clonetoken2 = "";

        switch (wallet.token) {
          case "btc":
           token = "BTC";
           break;
          case "eth":
            token = "ETH";
            clonetoken = "USDC ERC20";
            clonetoken2 = "USDT ERC20";
            break;

          case "usdt_erc20":
            token = "USDT ERC20";
            clonetoken = "ETH";
            clonetoken2 = "USDC ERC20";
            break;

          case "usdc_erc20":
            token = "USDC ERC20";
            clonetoken = "ETH";
            clonetoken2 = "USDT ERC20";
            break;

          // Map TRON, BNB, and SOL tokens also to Ethereum-style names
          case "trx":
            token = "TRX";
            clonetoken = "USDT TRC20";
            break;

          case "usdt_trc20":
            token = "USDT TRC20";
            clonetoken = "TRX";
            break;

          case "bnb":
            token = "BNB";
            clonetoken = "USDT BEP20";
            break;

          case "usdt_bep20":
            token = "USDT BEP20";
            clonetoken = "BNB";
            break;

          case "sol":
            token = "SOL";
            clonetoken = "USDT SPL";
            clonetoken2 = "USDC SPL";
            break;

          case "usdt_spl":
            token = "USDT SPL";
            clonetoken = "SOL";
            clonetoken2 = "USDC SPL";
            break;

          case "usdc_spl":
            token = "USDC SPL";
            clonetoken = "SOL";
            clonetoken2 = "USDT SPL";
            break;

          default:
            token = wallet.token.toUpperCase();
            break;
        }

        toast.success(
          `${token}${ " and "+clonetoken}${clonetoken2 ? " and " + clonetoken2 : ""} wallet is created successfully!`
        );

      // }
      // const result = await mainService.createFiatAccount(currency);
      // if (result.success) {
      //   const data = {
      //     virtual: user.virtualDash,
      //     cryptoPrices: cryptoPrices,
      //     fiatPrices: fiatPrices
      //   }
      //   dispatch(getMainWallets(data));
      // }
      return true;

    } catch (error) {
      throw error;
    }
  }
  return (
    <div className="flex flex-col gap-[30px]">
       {/* {user.accountType !=="EXPRESS" && ( */}

        {/* FIAT Wallets y Cards Wallets lado a lado */}
        <div className="flex flex-wrap gap-16">
          {/* FIAT Wallets */}
          <div className="flex-shrink-0">
            <h2 className="wallet-section-title">FIAT Wallets</h2>
            <div className="wallet-cards-container flex-wrap justify-center sm:justify-start">
                <MainAccount
                  key={"USD"}
                  walletType={FIAT_WALLETS[0]}
                  isCheckingMainData={isCheckingMainData}
                  // createWallet={createWallet}
                  showUsdForm = {showUsdForm}
                />
            </div>
          </div>

          {/* Cards Wallets */}
          <div className="flex-shrink-0">
            <MastercardCardSection />
          </div>
        </div>
       {/* )} */}
      {/* {showUsdForm && (
        <RailDataCompletionForm
          missingFields={usdFormMissingFields}
          userData={usdFormData}
          onSubmit={handleRailFormSubmit}
          onCancel={() => setShowUsdForm(false)}
          isLoading={false}
        />
      )} */}

      {/* <div>
        <h2 className="wallet-section-title">Custodian Crypto Wallets</h2>
        <div className="wallet-cards-container flex-wrap justify-center sm:justify-start">
          {CUSTODIAN_WALLETS.map((walletType) => (
            <WalletCard
              key={walletType.currency}
              walletType={walletType}
              isCheckingMainData={isCheckingMainData}
              createWallet={createWallet}
              showUsdForm = {showUsdForm}
            />
          ))}
        </div>
      </div>*/}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="wallet-section-title mb-0">Crypto Wallets</h2>
          <button
            onClick={() => setShowCryptoInfoModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200 text-sm font-medium shadow-sm"
            title={t('wallets.infoButton')}
          >
            <Info size={18} />
            <span className="hidden sm:inline">{t('wallets.infoButton')}</span>
          </button>
        </div>
        <div className="wallet-cards-container flex-wrap justify-center sm:justify-start">
          {CRYPTO_WALLETS.map((wallet) => (
            <WalletCard
              key={wallet.token}
              wallet={wallet}
              isCheckingMainData={isCheckingMainData}
              createWallet={createWallet}
              showUsdForm = {showUsdForm}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slide-down {
          animation: slideDown 0.5s ease-out;
        }
      `}</style>
      {showCryptoInfoModal && (
        <CryptoWalletsInfoModal onClose={() => setShowCryptoInfoModal(false)} />
      )}
    </div>
  );
}